import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClassificacaoPipeModule } from '../../classificacao/pipes';
import { TipoClassificacaoSelectModule } from '../../tipo-classificacao/select';
import { ClassificacaoSelectModule } from '../../classificacao/select';

import { GrupoClasssificacaoItemClassificacaoFormComponent } from './form';

@NgModule({
    imports: [
        SharedModule,
        ClassificacaoPipeModule,
        TipoClassificacaoSelectModule,
        ClassificacaoSelectModule
    ],
    declarations: [
        GrupoClasssificacaoItemClassificacaoFormComponent
    ],
    exports: [
        GrupoClasssificacaoItemClassificacaoFormComponent
    ]
})
export class GrupoClassificacaoClassificacaoModule { }
